module.exports = __webpack_public_path__ + "static/img/home_part2@2x.1d8a063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part2@2x.jpg
// module id = i1rR
// module chunks = 0